export default __webpack_public_path__ + "static/media/whiteXICcon.6d1fb3f0.svg";